import { ODataGetListFormModel } from '@evorait/pace-forms';
import { createAction, emptyProps, props } from '@ngrx/store';

export const getTestFormsList = createAction('[Pace Authors] get test form list for authors', emptyProps);

export const getTestFormsListSuccess = createAction(
    '[Pace Authors] get test form list for authors success',
    props<{ formsList: ODataGetListFormModel[] }>(),
);

export const getTestFormsListError = createAction(
    '[Pace Authors] get test forms list Error',
    props<{ error: unknown }>(),
);

export const getEquipmentsWithMatSer = createAction(
    '[Pace Authors] get Equipments with mat/ser',
    props<{ materialNumber: string; serialNumber: string; docId: string }>(),
);

export const getFormWithDocId = createAction('[Protocols] get form with order number', props<{ docId: string }>());

export const getEquipmentsError = createAction('[Pace Authors] get Equipments Error', props<{ error: unknown }>());

export const navigateToForms = createAction('[Pace Authors] Navigate to Forms', props<{ docId: string }>());
